/**
 * HR approval-assignment writes over /api/v1/hr/approval-assignments.
 *
 * Backs the org-chart popover "Change approver" control. HR / Director /
 * Exec Director only — 403s from the API bubble up as ApiError.
 */
import { apiRequest } from './client'

/** Set (or change) an employee's single primary approver. Backs the
 *  org-chart popover "Change approver" control. */
export async function setPrimaryApprover(
  employeeId: string,
  primaryApproverId: string,
): Promise<void> {
  await apiRequest<{ employeeId: string; primaryApproverId: string }>(
    `/api/v1/hr/approval-assignments/${employeeId}`,
    { method: 'PUT', body: { primaryApproverId } },
  )
}

/** Clear an employee's primary approver, leaving them unassigned. Backs the
 *  Approvers admin surface's "Remove member" control — the employee has no
 *  approver until reassigned, so the caller warns before calling this. */
export async function removePrimaryApprover(employeeId: string): Promise<void> {
  await apiRequest<void>(`/api/v1/hr/approval-assignments/${employeeId}`, {
    method: 'DELETE',
  })
}
